module.exports = __webpack_public_path__ + "static/media/ehealth_dental_banner_desktop.09522105.jpg";